import { ref, onMounted, onUnmounted } from 'vue'

export const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const query = `(max-width: ${MOBILE_BREAKPOINT}px)`
  const isMobile = ref(typeof window !== 'undefined' ? window.matchMedia(query).matches : false)

  function update() {
    isMobile.value = window.matchMedia(query).matches
  }

  onMounted(() => {
    update()
    window.addEventListener('resize', update)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', update)
  })

  return isMobile
}
